
export function deviceWidth(){

    let set_width = window.innerWidth;
    let breakepoints = {
      sm: "576",
      md: "768",
      lg: "992",
      xl: "1200",
      xxl: "1400",
    };
    let breakepoint_return = ""

    if( set_width < breakepoints.sm ){
        breakepoint_return = "xs";
    } else if (set_width < breakepoints.md ){
        breakepoint_return = "sm";
    } else if ( set_width < breakepoints.lg ){
        breakepoint_return = "md"
    } else if ( set_width < breakepoints.xl ){
        breakepoint_return = "lg"
    } else if ( set_width < breakepoints.xxl){
        breakepoint_return = "xl"
    } else (
        breakepoint_return = "xxl"
    )



    let result = {
        width : window.innerWidth,
        breakepoint: breakepoint_return
    };
    
    // let result = "20"
    
    return result;
}

